import * as React from 'react';
import { map } from 'lodash';
import { Info } from '../../../components/Info';
import { Button, Col, Row } from 'react-bootstrap';
import { ICollapsable } from '../../../../../services/quote/models';

interface IAdmiralCardProps {
  children: any,
  icon: string | any,
  title: string,
  editMode?: boolean,
  handleEdit?: any,
  dataToDisplay?: any,
  infoColor?: string,
  infoText?: string | any,
  subTitle?: string,
  noPadding?: boolean,
  showSaveButton?: boolean,
  noEditModeDisplay?: boolean
  forceTitle?: boolean;
  noMargin?: boolean;
  handleCollapse?: any,
  collapsable?: ICollapsable;
  useCollapse?: boolean;
  headerMessage?: string;
  headerMessageOnCollapsed?: JSX.Element;
}

export const AdmiralCard = ({
                              children,
                              icon,
                              title,
                              editMode = true,
                              handleEdit = null,
                              forceTitle = false,
                              dataToDisplay = null,
                              infoColor = 'blue',
                              infoText = '',
                              subTitle = '',
                              noPadding = false,
                              noMargin = false,
                              showSaveButton = false,
                              noEditModeDisplay = false,
                              collapsable,
                              handleCollapse = null,
                              useCollapse = true,
                              headerMessage,
                              headerMessageOnCollapsed,
                            }: IAdmiralCardProps) => {

  const isIconElement = typeof icon === 'object'


  const renderCollapsedCardHeader = (isEditable: boolean) => {
    return (
      <div className={'adm-card-section-header'}>
        <div className={'title-row'}>
          {icon && (
            <div className={isEditable ? 'adm-icon-circle green ' : 'adm-icon-circle'}>
              <img src={require(`../../../img/${icon}`)} alt={''}/>
            </div>
          )}

          <div className={'adm-card-title'}>
            <h3>
              {title}
            </h3>
          </div>
          {isEditable && (
            <>
              <div className={'adm-card-edit'} style={{ cursor: 'pointer' }}
                   onClick={handleCollapse}>CHANGE
              </div>
              <img src={require('../../../img/edit.svg')} alt={'admiral'}/>
            </>
          )}
        </div>
        {headerMessageOnCollapsed && (
          <div className={'message'}>{headerMessageOnCollapsed}</div>
        )}
      </div>
    )
  }

  if (collapsable?.opened === false && collapsable?.isEditable === false) {
    return (
      <>
        <div className={'adm-card'}>
          {renderCollapsedCardHeader(false)}
        </div>
      </>
    )
  }

  if (collapsable?.opened === false && collapsable?.isEditable === true && useCollapse) {
    return (
      <>
        <div className={'adm-card'}>
          {renderCollapsedCardHeader(true)}
        </div>
      </>
    )
  }

  return (
    <div className={'adm-card'} style={noMargin ? { marginTop: '0' } : { marginTop: '20px' }}>
      <div className={'adm-card-section-header'}>
        <div className={editMode ? 'title-row' : 'title-row edit'}>
          <div className={editMode ? 'adm-icon-circle' : 'adm-icon-circle green'}>
            {isIconElement && (
              <>
                {icon}
              </>
            )}
            {!isIconElement && (
              <img src={require(`../../../img/${icon}`)} alt={''}/>
            )}
          </div>
          <div className={editMode ? 'adm-card-title' : 'adm-card-title edit'}>
            {editMode && (
              <h3>{title}</h3>
            )}
            {!editMode && dataToDisplay && (
              map(dataToDisplay, (value, key) => {
                if (value) {
                  return (
                    <div style={{ textTransform: 'capitalize' }}>{value}</div>
                  )
                }
              })
            )}
            {!editMode && forceTitle && (
              <h3>{title}</h3>
            )}
            {subTitle && (
              <div>{subTitle}</div>
            )}
          </div>
          {!editMode && handleEdit && (
            <>
              <div className={'adm-card-edit'} style={{ cursor: 'pointer' }}
                   onClick={handleEdit.bind(this, true)}>CHANGE
              </div>
              <img src={require('../../../img/edit.svg')} alt={'admiral'}/>
            </>
          )}
        </div>
        {headerMessage && (<div className={'message'}>{headerMessage}</div>)}
      </div>
      {infoColor && infoText && (
        <Info text={infoText}/>
      )}
      {editMode && (
        <div className={noPadding ? 'adm-card-section-body no-padding' : 'adm-card-section-body'}>
          {children}
          {showSaveButton && (
            <Row>
              <Col xs={12}>
                <Button
                  bsSize={'small'}
                  type="button"
                  block={true}
                  onClick={handleEdit.bind(this, false)}
                  className={'admiral-primary-btn'}>
                  SAVE
                </Button>
              </Col>
            </Row>
          )}
        </div>
      )}
      {!editMode && noEditModeDisplay && (
        <div className={noPadding ? 'adm-card-section-body no-padding' : 'adm-card-section-body'}>
          {children}
        </div>
      )}
    </div>
  )
}
